module.exports = __webpack_public_path__ + "static/media/about-limits.901a61cb.svg";